import { useEffect, useState } from 'react';

// navigator.onLine only tells us about the network interface, not real reachability.
// It is good enough as a fast signal; the ApiService layer additionally falls back
// to offline when an actual request fails with a network error.
export function isOnline() {
  return typeof navigator === 'undefined' ? true : navigator.onLine !== false;
}

// Offline support is opt-in per event. The offline banner (mounted only on the
// registrations + scan pages) records whether the current event allows offline
// use; the ApiService layer consults this before serving from the offline cache.
// ponytail: single global flag, since only one event context is active at a time.
let offlineAllowed = false;
export function setOfflineAllowed(allowed) {
  offlineAllowed = !!allowed;
}
export function isOfflineAllowed() {
  return offlineAllowed;
}

export default function useOnlineStatus() {
  const [online, setOnline] = useState(isOnline());

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
